import { jsx as _jsx } from "react/jsx-runtime";
import { Box, Typography, styled } from '@mui/material';
import { snakeCase } from 'lodash';
export const PentairStatusBox = styled(Box)(({ theme, value, }) => {
    const getColor = () => {
        const status = snakeCase(value);
        switch (status) {
            // Green
            case 'completed':
            case 'success':
            case 'done':
            case 'approved':
            case 'ready':
                return {
                    backgroundColor: theme.palette.success.main,
                    color: '#fff',
                };
            // Orange
            case 'warning':
            case 'expired':
                return {
                    backgroundColor: theme.palette.warning.main,
                    color: '#fff',
                };
            // Red
            case 'error':
            case 'failed':
            case 'denied':
            case 'required':
                return {
                    backgroundColor: theme.palette.error.main,
                    color: '#fff',
                };
            // Soft Gray
            case 'draft':
            case 'concept':
            case 'initial_draft':
            case 'modified_draft':
                return {
                    backgroundColor: theme.palette.lightGray.main,
                    color: theme.palette.softGray.main,
                };
            // Pentair Blue
            case 'pending':
            default:
                return {
                    backgroundColor: theme.palette.blue.main,
                    color: '#fff',
                };
        }
    };
    const { backgroundColor, color } = getColor();
    return {
        backgroundColor,
        color,
        display: 'inline-block',
        '& span': {
            color,
            fontSize: 12,
            fontWeight: 500,
            textTransform: 'uppercase',
            whiteSpace: 'nowrap',
        },
    };
});
export const PentairStatusLabel = ({ value, ...props }) => {
    return (_jsx(PentairStatusBox, { value: value, ...props, padding: '4px 12px', children: _jsx(Typography, { component: "span", children: value }) }));
};
